import { useQuery } from '@apollo/react-hooks';
import {
  OutageDetailsByCounty,
  OutageDetailsByCountyList,
} from '../../../__generated__/pge-types';
import { getOutagesByCountyOrZipCode } from '../../../queries/outage.query';
import { useErrorNotification } from '../components/common/error-notification';
import { useEffect } from 'react';

export const useGetOutagesByCountyOrZip = () => {
  const { data, error, loading, refetch } = useQuery<{
    getOutagesByCountyOrZipCode: OutageDetailsByCountyList;
  }>(getOutagesByCountyOrZipCode, {
    variables: {
      params: {
        type: 'OUTAGE_BY_COUNTY',
      },
    },
  });
  const { setErrorNotification } = useErrorNotification();
  useEffect(() => {
    error && setErrorNotification();
  }, [error]);

  return {
    outages: (data?.getOutagesByCountyOrZipCode?.outageByCountyList ??
      []) as OutageDetailsByCounty[],
    error,
    loading,
    refetch,
  };
};
